export default __webpack_public_path__ + "static/media/back_rand1.82694940.jpg";